export default {
  steps: {
    setup_fee: 'Installatiekosten',
    business_info: 'Bedrijfsgegevens',
    create_preview: 'Voorbeeldcontract aanmaken',
    preview: 'Contract bekijken',
    sign: 'Contract ondertekenen',
  },
  buttons: {
    next: 'Contract bekijken',
    save_and_continue: 'Opslaan & doorgaan',
    update: 'Voorbeeld bijwerken',
    cancel: 'Huidige annuleren',
    skip: 'Contractaanmaak overslaan',
  },
  create_preview: {
    header: 'Voorbeeldcontract aanmaken',
    description: 'Voer de ontvangersgegevens voor het contract in. Je kunt ze nog wijzigen voor het verzenden.',
  },
  sign: {
    update_notice: 'Om het contract bij te werken, annuleer het huidige en bewerk de gegevens.',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
  },
};
